import React, { useState, useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import EnhancedTextarea from 'components/EnhancedTextarea';
import LoadBlur from 'components/LoadBlur';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import store from 'lib/store';
import { Box } from '@mui/material';
import apiGateway from '../../lib/apiGateway';
import PickMultipleMedia from './PickMultimedia';

const useStyles = makeStyles(theme => ({
  card: {
    // backgroundColor: theme.palette.text.primary,
    color: '#000',
    boxShadow: 'none',
    width: '80%',
    margin: '0px auto',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
    backgroundColor: '#ffffff !important',
  },
  cardHeader: {
    color: '#000 !important',
    paddingLeft: 0,
    fontWeight: 500,
    fontSize: '1rem !important',
  },
  cardSubHeader: {
    color: '#000 !important',
    paddingLeft: 0,
    fontSize: '0.8rem !important',
  },
  cardContent: {
    // border: '1px solid #898989',
  },
  cardActions: {
    height: 50,
    // backgroundColor: '#E9F5FC',
    // border: '1px solid #898989',
    padding: '3px 8px',
  },
  button: {
    paddingLeft: 20,
    paddingRight: 20,
    borderRadius: 20,
    // backgroundColor: '#0076BB',
    // color: 'white',
    // '&:hover': {
    //   // backgroundColor: '#1883c1',
    //   color: 'white',
    // },
  },
  disabledButton: {
    borderRadius: 20,
    fontWeight: 700,
    border: '1px solid #898989',
    color: 'none !important',
    backgroundColor: 'none !important',
    // color: '#898989!important',
    // backgroundColor: '#F5F5F5!important',
  },
}));

const JoinConversation = ({
  loggedIn,
  showSignInDialog,
  placeholder,
  eventDetails,
  perId,
  afterConvSubmit,
}) => {
  const classes = useStyles();
  const [activityGroup, setActivityGroup] = useState([]);
  const [showTextArea, setShowTextArea] = useState(true);
  const [showImageArea, setShowImageArea] = useState(false);
  const [loading, setLoading] = useState(false);
  const [captionText, setCaptionText] = useState('');
  const [errors] = useState('');
  const [values, setValues] = useState('');
  const [image, setImage] = useState({});

  useEffect(() => {
    (async () => {
      const accTk = await store.get('accessToken');
      if (accTk || perId) {
        setShowImageArea(false);
        setShowTextArea(true);
        apiGateway
          .getActivityGroupByEventId(0)
          .then(res => {
            setActivityGroup(res);
          })
          .catch(err => {
            // eslint-disable-next-line no-console
            console.log(err);
          });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = e => {
    setShowImageArea(false);
    setImage({});
    const {
      target: { value },
    } = e;
    setCaptionText(value);
    setValues(value);
  };

  const handleImageChange = data => {
    if (data && data.length > 0) {
      setShowTextArea(false);
      setShowImageArea(true);
      const txt = values || '';
      setCaptionText(txt);
      setValues('');
      setImage(data[0]);
    } else {
      setShowImageArea(false);
      setImage({});
      setCaptionText('');
    }
  };

  const submit = () => {
    if (!loggedIn) {
      showSignInDialog();
      return;
    }
    setLoading(true);
    if (values !== '' || Object.keys(image).length > 0) {
      const act = activityGroup.find(val => val.name === 'GlobalGroup');
      if (values !== '') {
        const task = act?.activities[0]?.tasks.find(
          tsk => tsk.name === 'DISCUSSION',
        );
        const payload = {
          activityGroupId: act?.id || '',
          activityId: act?.activities[0]?.id || '',
          eventId: eventDetails?.id,
          sponsorId: eventDetails?.sponsorId,
          userId: perId,
          tasks: [
            {
              task: 'DISCUSSION',
              taskId: task?.id || '',
              request: {
                body: values,
                productId: eventDetails?.id,
                productName: 'Event',
              },
            },
          ],
        };
        apiGateway.submitActivityComment(payload).then(res => {
          setLoading(false);
          afterConvSubmit();
          setImage({});
          setCaptionText('');
          setValues('');
          // eslint-disable-next-line no-console
          console.log(res);
        });
      } else {
        const evtId = eventDetails?.id || '';
        const signedUrlPayload = {
          contentType: image.metaData.type,
          fileName: image.metaData.name,
          loaderType: 'ASSET_IMAGE',
          metaData: {
            evtId,
            perId,
          },
        };
        apiGateway
          .generateFileUploadPresignedUrl(signedUrlPayload)
          .then(presignedUrl => {
            if (!presignedUrl) {
              setLoading(false);
              return;
            }
            apiGateway.uploadUGC(presignedUrl, image.metaData).then(r => {
              if (!r.ok) {
                setLoading(false);
                return;
              }
              setTimeout(() => {
                const task = act?.activities[0]?.tasks.find(
                  tsk => tsk.name === 'MEDIA_UPLOAD',
                );
                const payload = {
                  activityGroupId: act?.id || '',
                  activityId: act?.activities[0]?.id || '',
                  eventId: eventDetails?.id,
                  sponsorId: eventDetails?.sponsorId,
                  userId: perId,
                  tasks: [
                    {
                      task: 'MEDIA_UPLOAD',
                      taskId: task?.id || '',
                      request: {
                        isSocial: true,
                        assetPayloads: [
                          {
                            assetType: 'IMAGE',
                            basename: image?.metaData?.name || '',
                            caption: captionText || '',
                            mimeType: image?.metaData?.type || '',
                          },
                        ],
                      },
                    },
                  ],
                };
                apiGateway.submitActivityComment(payload).then(res => {
                  setLoading(false);
                  afterConvSubmit();
                  setImage({});
                  setShowImageArea(false);
                  setShowTextArea(true);
                  // eslint-disable-next-line no-console
                  console.log(res);
                });
              }, 500);
            });
          })
          .catch(() => {
            setLoading(false);
            return null;
          });
      }
    }
  };

  return (
    <Card sx={{ boxShadow: 3 }} classes={{ root: classes.card }}>
      <LoadBlur loading={loading}>
        <CardHeader
          classes={{
            root: classes.cardHeader,
            title: classes.cardHeader,
            subheader: classes.cardSubHeader,
          }}
          title='Join the Conversation'
          subheader='Thoughts? Pics? Both? Share them below!'
        />
        <CardContent classes={{ root: classes.cardContent }}>
          {showTextArea && (
            <EnhancedTextarea
              borderColor='#dfdfdf'
              color='#000'
              autoFocus={false}
              errorText={errors?.body}
              name='body'
              disabled={!loggedIn}
              onBlur={onChange}
              onChange={onChange}
              placeholder={
                !loggedIn ? 'Sign In to join conversation.' : placeholder
              }
              value={values}
            />
          )}
          {showImageArea && (
            <div style={{ position: 'relative' }}>
              <CancelIcon
                onClick={() => {
                  setShowImageArea(false);
                  setShowTextArea(true);
                  setValues(captionText);
                }}
                style={{ position: 'absolute', right: '0', top: '-5' }}
              />
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img
                  src={image?.blob || ''}
                  alt={image?.metaData?.name || 'Upload photo'}
                  id={image?.metaData?.name || 'image'}
                  style={{ display: 'block', width: '40%', height: '40%' }}
                  loading='lazy'
                />
              </div>
              <TextField
                fullWidth
                variant='outlined'
                value={captionText}
                onChange={evt => setCaptionText(evt.target.value)}
                label='Image caption'
                style={{ display: 'block' }}
                InputProps={{
                  style: {
                    borderColor: 'black',
                    color: 'black',
                  },
                }}
                InputLabelProps={{
                  style: {
                    color: 'black',
                  },
                }}
              />
            </div>
          )}
        </CardContent>
        <CardActions classes={{ root: classes.cardActions }}>
          <PickMultipleMedia
            key='additional'
            handleChange={handleImageChange}
            additional={false}
            type='IMAGE'
            format={{
              name: 'Format',
              type: 'TEXT',
              multiple: false,
              required: true,
              value: ['JPG', 'PNG', 'HEIF'],
            }}
          />
          <Box style={{ flexGrow: 1 }} />
          <Button
            variant='contained'
            size='small'
            // variant='contained'
            sx={{
              backgroundColor: '#F48120 !important',
              opacity:
                loggedIn
                && values === ''
                && image
                && Object.keys(image).length === 0
                  ? 0.5
                  : 1,
            }}
            disabled={
              loggedIn
              && values === ''
              && image
              && Object.keys(image).length === 0
            }
            onClick={submit}
            // classes={{ root: classes.button }}
          >
            {loggedIn ? 'Submit' : 'Sign In'}
          </Button>
        </CardActions>
      </LoadBlur>
    </Card>
  );
};
JoinConversation.propTypes = {
  autoFocus: PropTypes.bool,
  disableConversation: PropTypes.bool,
  placeholder: PropTypes.string,
  eventDetails: PropTypes.any.isRequired,
  perId: PropTypes.string.isRequired,
  afterConvSubmit: PropTypes.func,
  loggedIn: PropTypes.bool,
  showSignInDialog: PropTypes.func,
};

export default JoinConversation;
